import { env } from 'portal/lib/config/env-config.js'

export const RECORD = {
  EDIT: `${env.NX_ADMIN_URL}/accounts/:accountId/projects/:projectId/:moduleName/record-v2/:recordId/edit`
}
